import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHead } from "@/components/Reveal";
import { scrollToId } from "@/App";

const FAQS = [
  {
    q: "Where do you operate?",
    a: "We're based in Melbourne and cover the whole Melbourne Metropolitan area. Regional Victoria — including Geelong, Ballarat and Bendigo — is available by appointment. Enquire and we'll let you know what's possible.",
  },
  {
    q: "What surface is the court made of?",
    a: "Every PopUp court is finished with JOOLA-branded professional surfacing — top of the range and the brand the pros trust. Expect a true, consistent bounce and pro-level grip underfoot, indoors or outdoors.",
  },
  {
    q: "How much space do I need?",
    a: "The playing lines measure 13.41m × 6.10m. We recommend a total footprint of about 18.3m × 9.1m per court including safe run-off, though tighter fits work from around 16.5m × 8m. Indoors, aim for 5m+ ceiling clearance. See our Court Specs section for the full diagram.",
  },
  {
    q: "What surface do you need underneath?",
    a: "Any level, hard surface works — indoors or outdoors. Concrete, asphalt, timber floors, synthetic surfaces and carparks all play well. Grass isn't suitable. Unsure about your venue? Just ask and we'll advise.",
  },
  {
    q: "How far in advance should I book?",
    a: "As much notice as possible. Our courts book out fast, especially on weekends and during holiday periods. The more lead time you give us, the better the chance of securing your preferred date.",
  },
  {
    q: "What's included in every booking?",
    a: "Every booking includes the JOOLA-surfaced court, net, paddles, balls, delivery to your venue, setup and pack-down. Facilitation and hosting by our team is available as part of your package.",
  },
  {
    q: "Can you do custom branded courts?",
    a: "Yes — we can produce custom branded courts in a range of dimensions and configurations. Perfect for product launches, brand activations and major events. Production lead times apply, so contact us early.",
  },
  {
    q: "How much does it cost?",
    a: "Pricing depends on duration, number of courts and add-ons. Request a free quote and we'll send a tailored proposal within 1 hour.",
  },
  {
    q: "Do you cover Geelong and regional Victoria?",
    a: "These sit outside our standard Melbourne Metro coverage, but we can travel by appointment. Get in touch to discuss.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="relative bg-carbon py-24 lg:py-32" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <SectionHead eyebrow="Common questions" title="Frequently asked questions" testid="faq-heading" />
        <Reveal>
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid="faq-accordion-item"
                className="border-white/10"
              >
                <AccordionTrigger className="py-6 text-left font-display text-lg font-bold uppercase tracking-tight text-white hover:text-volt sm:text-xl">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm leading-relaxed text-white/60 sm:text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
        <Reveal delay={0.1} className="mt-10">
          <p className="text-white/60">
            Still have questions?{" "}
            <button
              data-testid="faq-contact-link"
              onClick={() => scrollToId("#quote")}
              className="font-semibold text-volt underline-offset-4 hover:underline"
            >
              Get in touch
            </button>{" "}
            and we'll get back to you within 1 hour.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
